export class HoClaimMessages {
  static readonly CLAIM_HO_SUCCESS_INI = 'El Handover';
  static readonly CLAIM_HO_SUCCESS_END = 'se tomó exitosamente.';
  static readonly CLAIM_HO_ERROR_INI =
    'Hubo un problema y el Handover no pudo ser tomado.';
  static readonly CLAIM_HO_ERROR_END = 'Por favor, intentelo nuevamente.';
  static readonly SUCCESS_NOTIFICATION = true;
  static readonly ERROR_NOTIFICATION = false;
}

export class HoReleaseMessages {
  static readonly RELEASE_HO_SUCCESS_INI = 'El Handover';
  static readonly RELEASE_HO_SUCCESS_END = 'se liberó exitosamente.';
  static readonly RELEASE_HO_ERROR_INI =
    'Hubo un problema y el Handover no pudo ser liberado.';
  static readonly RELEASE_HO_ERROR_END = 'Por favor, intentelo nuevamente.';
  static readonly SUCCESS_NOTIFICATION = true;
  static readonly ERROR_NOTIFICATION = false;
}
